var map = {
	"./capa_placas.jpg": 350,
	"./placas (1).jpg": 351,
	"./placas (2).jpg": 352,
	"./placas (3).jpg": 353,
	"./placas (4).jpg": 354,
	"./placas (5).jpg": 355,
	"./placas (6).jpg": 356,
	"./placas (7).jpg": 357
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19;


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Placas nonrecursive \.(jpg|jpeg|png|gif)$
// module id = 19
// module chunks = 0